import { Urls } from '@/constants/urls';
import { handleExternalLink } from '@/utils/link-props';
import { Divider, Link, Text } from '@cmpsr/components';

export type TestFooterVariant = 'primary' | 'secondary';

export default function TestFooter() {
  return (
    <>
      <Divider my={4} />
      <Text variant="text-body-regular" color="text-primary">
        You can find more information on{' '}
        <Link
          target="_blank"
          {...handleExternalLink({ href: Urls.screening_sensitivity_specificity })}
          aria-label="Navigate to the Catch blog"
          color="text-link-secondary-default"
          textDecoration="underline"
          textUnderlineOffset={2}
        >
          our blog
        </Link>{' '}
        regarding test sensitivity and specificity, as well as positive and negative predictive value.
      </Text>
    </>
  );
}
